import "./H2.css"


export default function H2({ text }) {
  return (
    <h2>{text}</h2>
  )
}
